const { StrategyManager } = require("./strategyManager.js");
const {getFeaturePriority } = require("./Features.js");

//Initialise the straties which can be run on the client side
function initClientSideStrategies(){
    StrategyManager.registerStrategy("DueDate", getDuedataPriority);
    StrategyManager.registerStrategy("Gantt", getGanttPriority);
    StrategyManager.registerStrategy("EpicFlow", getEpicFlowPriority);
    StrategyManager.registerStrategy("EpicFlowV2", getEpicFlowV2Priority);
    StrategyManager.registerStrategy("Features", getFeaturePriority);
}


//Duedate priority system as described in the spec
function getDuedataPriority(simulator){
    var readyTasks = simulator.projectPool.getAllReadyTasks(simulator.projectPool.projects)

    var taskPriorities = {};
    readyTasks.forEach(task => {
        taskPriorities[task.getUniqueID()] = calculateDuedatePriority(task, simulator);
    });

    readyTasks.sort((task1,task2) => {
        var proj1Duedata = taskPriorities[task1.getUniqueID()];
        var proj2Duedata = taskPriorities[task2.getUniqueID()]
        
        return proj1Duedata - proj2Duedata ||  task1.project.projectIndex - task2.project.projectIndex;
    })

    return readyTasks;
}

function calculateDuedatePriority(task, simulator){
    var dueDate = task.project.getDueDate();

    return dueDate;
}
    

//Gantt priority system as described in the spec
function getGanttPriority(simulator){
    var readyTasks = simulator.projectPool.getAllReadyTasks(simulator.projectPool.projects)

    var taskPriorities = {};
    readyTasks.forEach(task => {
        taskPriorities[task.getUniqueID()] = calculateGanttPriority(task, simulator);
    });

    readyTasks.sort((task1,task2) => {

        var task1OriginalEnd = taskPriorities[task1.getUniqueID()];
        var task2OriginalEnd = taskPriorities[task2.getUniqueID()];

        return task1OriginalEnd - task2OriginalEnd || task1.project.projectIndex - task2.project.projectIndex;
    })

    return readyTasks;
}

function calculateGanttPriority(task, simulator){
    var task1OriginalEnd = task.originalStartHour + task.totalWorkHours;

    return task1OriginalEnd;
}

//Epicflow priority system as described in the spec
function getEpicFlowPriority(simulator){
    var readyTasks = simulator.projectPool.getAllReadyTasks(simulator.projectPool.projects)


    var taskPriorities = {};
    readyTasks.forEach(task => {
        taskPriorities[task.getUniqueID()] = calculateEpicFlowPriority(task, simulator);
    });

    readyTasks.sort((task1,task2) => {
        
        var project1ratio = taskPriorities[task1.getUniqueID()];
        var project2ratio = taskPriorities[task2.getUniqueID()];


        return project1ratio - project2ratio ||  task1.project.projectIndex - task2.project.projectIndex;
    })

    return readyTasks;
}

//Epicflow priority system as described in the spec
function getEpicFlowV2Priority(simulator){
    var readyTasks = simulator.projectPool.getAllReadyTasks(simulator.projectPool.projects)


    var taskPriorities = {};
    readyTasks.forEach(task => {
        taskPriorities[task.getUniqueID()] = calculateEpicFlowV2Priority(task, simulator);
    });

    readyTasks.sort((task1,task2) => {
        
        var project1ratio = taskPriorities[task1.getUniqueID()];
        var project2ratio = taskPriorities[task2.getUniqueID()];


        return project1ratio - project2ratio ||  task1.project.projectIndex - task2.project.projectIndex;
    })

    return readyTasks;
}

function calculateEpicFlowPriority(task, simulator){
    var project = task.project;

    var projectbuffer = project.getDueDate() - project.getMinimumEndHour();
    var projectratio =  projectbuffer / project.getDueDate();

    return projectratio;
}
function calculateEpicFlowV2Priority(task, simulator){
    var project = task.project;

    var remainingWork = project.getMinimumEndHour() - simulator.hoursPassed;
    var remainingTime = project.getDueDate() - simulator.hoursPassed;

    return -remainingWork / remainingTime ;
}



module.exports = { initClientSideStrategies };